
import filters from "@/mixins/filters";
export default {
	mixins: [filters],
	props: {
		values: Array,
		value: String,
		sum: Number
	},
	methods: {
		changePayment(value) {
			this.$emit('changePayment', value)
		},
		getPaymentOptions() {
			return {
				grid: true,
				values: this.values.map(val => {
					return val
				}),
				from: this.values.indexOf(this.value),
			};
		}
	}
}
